import config from "@/config";
import http from "@/utils/request";

export default {
    list: {
      url: `${config.API_URL}/api/ly/sms/page`,
      name: "短信信息分页",
      get: async function (data = {}, config = {}) {
        return await http.get(this.url, data, config);
      },
    },
    addAndEdit: {
      url: `${config.API_URL}/api/ly/sms/add`,
      name: "新增短信标题",
      post: async function (data = {}) {
        return await http.post(this.url, data);
      },
    },
    logList: {
      url: `${config.API_URL}/api/ly/sms/log/list`,
      name: "发送记录",
      get: async function (data = {}) {
        return await http.get(this.url, data);
      },
    },
    detail: {
      url: `${config.API_URL}/api/ly/sms/detail`,
      name: "短信详情",
      get: async function (data = {}) {
        return await http.get(`${this.url}${data}`, data);
      },
    },
};
